import PropTypes from 'prop-types';
import React from 'react';

import './DataDisplay.css';
import classNames from 'classnames';

export function DataDisplayRecord({
    header,
    data,
    loading = false
}) {
    return (
        <div className="data-display-record">
            <div className={classNames('data-display-record-header', {"bp6-skeleton": loading})}>
                {header}
            </div>
            <div className={classNames('data-display-record-body', {"bp6-skeleton": loading})}>
                {data}
            </div>
        </div>
    );
}

DataDisplayRecord.propTypes = {
    header: PropTypes.node.isRequired,
    data: PropTypes.node,
    loading: PropTypes.bool,
};